import { Form, Space } from "antd";
import { ItemInsuranceData } from "types/configTax.type";
import { InputNumberStyled, Styles } from "./styled";
import { isNil } from "lodash";

interface IProps {
  isRowAsHeader: boolean;
  isEdit: boolean;
  record: any;
  isCollapse?: boolean;
}

const InsuranceTax = (props: IProps) => {
  const { isRowAsHeader, isEdit, record, isCollapse } = props;
  const form = Form.useFormInstance();
  const convertFullWidthToHalfWidth = (text: string) => {
    return text
      .replace(/[\uff01-\uff5e]/g, (char) =>
        String.fromCharCode(char.charCodeAt(0) - 0xfee0),
      )
      .replace(/\u3000/g, " ");
  };

  if (isRowAsHeader) {
    const children = record.children || ([] as ItemInsuranceData[]);
    const insurance_tax =
      (children[0] &&
        !isNil(children[0].insurance_tax) &&
        children[0].insurance_tax + "") ||
      (children[1] &&
        !isNil(children[1].insurance_tax) &&
        children[1].insurance_tax + "") ||
      "";
    if (insurance_tax && isCollapse) {
      return (
        <div
          style={{
            textAlign: "right",
          }}
        >
          {insurance_tax} %
        </div>
      );
    }
    return <div>料率</div>;
  }
  if (!isEdit)
    return (
      <div
        style={{
          textAlign: "right",
        }}
      >
        {record.insurance_tax + "%"}
      </div>
    );
  const names = [
    record.industry_category_id.toString(),
    record.id.toString(),
    "insurance_tax",
  ];
  const formatToValidNumber = (input: string) => {
    const cleaned = input.replace(/[^0-9.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length > 2) {
      return `${parts[0]}.${parts.slice(1).join("")}`;
    }
    return cleaned;
  };
  const handleBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => {
    const value = formatToValidNumber(
      convertFullWidthToHalfWidth(e.target.value),
    );

    form.setFieldValue(names, value);
    form.validateFields([names]);
  };
  return (
    <Styles>
      {/* <Space
        direction="horizontal"
        style={{
          marginBottom: -23,
        }}
      > */}
      <Form.Item
        name={names}
        rules={[
          {
            required: true,
            message: "必須",
          },
        ]}
      >
        <InputNumberStyled placeholder="料率" onBlur={handleBlur} />
      </Form.Item>
      {/* </Space> */}
    </Styles>
  );
};

export default InsuranceTax;
